import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CsSelect } from 'components/antd-extension/CsSelect';
import { QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { VmTypeInt, VmTypeUtil } from 'utils/constants/vm-type';
import { ProductSummaryUtil } from 'components/exception/ProductSummaryPage/ProductSummaryUtil';

const IcfVmTypeSelect = ({
  isReadOnly,
  fieldValue,
  onChangeFieldValue,
}) => {
  const { t } = useTranslation();

  const hasVmTypeCloudGaming = ProductSummaryUtil.useHasVmTypeCloudGaming();

  const options = useMemo(() => {
    return VmTypeUtil.getAndroidOptions().filter(x => {
      return x.value !== VmTypeInt.CLOUD_GAMING || hasVmTypeCloudGaming;
    });
  }, [hasVmTypeCloudGaming]);

  const {
    terms,
  } = fieldValue || {};

  return (
    <CsSelect
      style={{ width: '100%', fontSize: '14px' }}
      mode='multiple'
      allowClear
      options={options}
      placeholder={t('issueCrashFilter.anyPlaceholder')}
      value={terms}
      onChange={(v) => {
        if (isReadOnly) {
          return;
        }
        onChangeFieldValue({ queryType: QueryType.TERMS, terms: v });
      }}
    />
  );
};

export default IcfVmTypeSelect;
